export const ROLE_CREATE = "ROLE_CREATE";
export const ROLE_CREATE_SUCCESS = "ROLE_CREATE_SUCCESS";
export const ROLE_CREATE_FAIL = "ROLE_CREATE_FAIL";

export const ROLE_LIST = "ROLE_LIST";
export const ROLE_LIST_SUCCESS = "ROLE_LIST_SUCCESS";
export const ROLE_LIST_FAIL = "ROLE_LIST_FAIL";

export const ROLE_UPDATE = "ROLE_UPDATE";
export const ROLE_UPDATE_SUCCESS = "ROLE_UPDATE_SUCCESS";
export const ROLE_UPDATE_FAIL = "ROLE_UPDATE_FAIL";

export const ROLE_DELETE = "ROLE_DELETE";
export const ROLE_DELETE_SUCCESS = "ROLE_DELETE_SUCCESS";
export const ROLE_DELETE_FAIL = "ROLE_DELETE_FAIL";

export const ADMIN_DASHBOARD_COUNT = "ADMIN_DASHBOARD_COUNT";
export const ADMIN_DASHBOARD_COUNT_SUCCESS = "ADMIN_DASHBOARD_COUNT_SUCCESS";
export const ADMIN_DASHBOARD_COUNT_FAIL = "ADMIN_DASHBOARD_COUNT_FAIL";